var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardDepartment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21,
    r: 21,
    fill: "#EFF3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 24.75C13.75 24.087 14.0134 23.4511 14.4822 22.9822C14.9511 22.5134 15.587 22.25 16.25 22.25H26.25C26.913 22.25 27.5489 22.5134 28.0178 22.9822C28.4866 23.4511 28.75 24.087 28.75 24.75",
    stroke: "#054CB3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 17.25V22.25",
    stroke: "#054CB3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 27.25C15.5 26.2835 14.7165 25.5 13.75 25.5C12.7835 25.5 12 26.2835 12 27.25V29.75C12 30.7165 12.7835 31.5 13.75 31.5C14.7165 31.5 15.5 30.7165 15.5 29.75V27.25Z",
    stroke: "#054CB3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 27.25C30.5 26.2835 29.7165 25.5 28.75 25.5C27.7835 25.5 27 26.2835 27 27.25V29.75C27 30.7165 27.7835 31.5 28.75 31.5C29.7165 31.5 30.5 30.7165 30.5 29.75V27.25Z",
    stroke: "#054CB3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23 12.25C23 11.2835 22.2165 10.5 21.25 10.5C20.2835 10.5 19.5 11.2835 19.5 12.25V14.75C19.5 15.7165 20.2835 16.5 21.25 16.5C22.2165 16.5 23 15.7165 23 14.75V12.25Z",
    stroke: "#054CB3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardDepartment);
export default __webpack_public_path__ + "static/media/dashboardDepartment.8dd3d6db8899ef605940490f03a64e3f.svg";
export { ForwardRef as ReactComponent };